import { MobileUser } from "@/pages/users/schema/users.schema";
import { AppColors } from "@/styles/colors";
import { CloseButton, Dialog, Flex, Grid, GridItem, Portal, Text } from "@chakra-ui/react";
import { LightMode } from "../ui/color-mode";
import dayjs from "dayjs";

interface Props {
  open: boolean;
  setOpen: (open: boolean) => void;
  user?: MobileUser;
}

export const MotivoBajaUserModal = ({ open, setOpen, user }: Props) => {
  return (
    <Dialog.Root
      placement="center"
      lazyMount
      open={open}
      onOpenChange={(e) => setOpen(e.open)}
    >
      <Portal>
        <Dialog.Backdrop />
        <Dialog.Positioner>
          <LightMode>
            <Dialog.Content
              width="90vw"
              maxWidth="700px"
              data-testid="motivo-baja-user-modal"
            >
              <Dialog.Header paddingY="16px" paddingLeft="24px">
                <Dialog.Title
                  fontWeight={600}
                  color={AppColors.GRAY_TEXT}
                  fontSize="18px"
                >
                  Motivo de baja de usuario
                </Dialog.Title>
              </Dialog.Header>

              <Dialog.Body paddingX="24px" paddingBottom="24px">
                <Flex flexDir="column" gap="20px">
                  <Grid templateColumns="repeat(3, 1fr)" gap="24px">
                    <GridItem>
                      <Text
                        fontWeight={700}
                        fontSize="14px"
                        color={AppColors.BLACK_TEXT_SECONDARY}
                        paddingBottom="6px"
                        borderBottom={`1px solid ${AppColors.WHITE_BORDER_1}`}
                      >
                        Nombre y Apellido
                      </Text>
                      <Text
                        fontSize="14px"
                        color={AppColors.GRAY_TEXT}
                        marginTop="8px"
                      >
                        {`${user?.nombre ?? ""} ${user?.apellido ?? ""}`.trim() || "-"}
                      </Text>
                    </GridItem>

                    <GridItem>
                      <Text
                        fontWeight={700}
                        fontSize="14px"
                        color={AppColors.BLACK_TEXT_SECONDARY}
                        paddingBottom="6px"
                        borderBottom={`1px solid ${AppColors.WHITE_BORDER_1}`}
                      >
                        Mail
                      </Text>
                      <Text
                        fontSize="14px"
                        color={AppColors.GRAY_TEXT}
                        marginTop="8px"
                      >
                        {user?.mail || "-"}
                      </Text>
                    </GridItem>

                    <GridItem>
                      <Text
                        fontWeight={700}
                        fontSize="14px"
                        color={AppColors.BLACK_TEXT_SECONDARY}
                        paddingBottom="6px"
                        borderBottom={`1px solid ${AppColors.WHITE_BORDER_1}`}
                      >
                        Celular
                      </Text>
                      <Text
                        fontSize="14px"
                        color={AppColors.GRAY_TEXT}
                        marginTop="8px"
                      >
                        {user?.movil || "-"}
                      </Text>
                    </GridItem>
                  </Grid>

                  <Flex flexDir="column">
                    <Text
                      fontWeight={700}
                      fontSize="14px"
                      color={AppColors.BLACK_TEXT_SECONDARY}
                      paddingBottom="6px"
                      borderBottom={`1px solid ${AppColors.WHITE_BORDER_1}`}
                    >
                      Motivo
                    </Text>
                    <Flex
                      marginTop="8px"
                      border={`1px solid ${AppColors.WHITE_BORDER_1}`}
                      borderRadius="8px"
                      padding="16px"
                      minH="90px"
                    >
                      <Text fontSize="14px" color={AppColors.GRAY_TEXT}>
                        {user?.motivoBaja || "-"}
                      </Text>
                    </Flex>
                    <Flex gap="8px" paddingTop="8px">
                      <Text fontSize="12px">Fecha de baja:</Text>
                      <Text fontSize="12px" color={AppColors.GRAY_TEXT}>
                        {user?.fechaBaja
                          ? dayjs(user.fechaBaja).format("DD/MM/YYYY HH:mm")
                          : "-"}
                      </Text>
                    </Flex>
                  </Flex>
                </Flex>
              </Dialog.Body>

              <Dialog.CloseTrigger asChild>
                <CloseButton size="sm" data-testid="motivo-baja-user-modal-close" />
              </Dialog.CloseTrigger>
            </Dialog.Content>
          </LightMode>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  );
};
